import { BffService } from '../bff.service'
import { FetchMethod } from '../../fetch/types/fetch-method.enum'
import { FetchResponse } from '../../fetch/types/fetch-response.type'
import { ConsumerEmailStepState } from '../../../modules/consumer/modules/consumer-workflow/modules/consumer-email-step/types/consumer-email-step-state.interface'

export class ConsumerEmailService extends BffService {
  public saveConsumerEmail(
    emailAddress: ConsumerEmailStepState['email'],
  ): FetchResponse<null> {
    return super.createAuthorizedRequest({
      method: FetchMethod.PATCH,
      url: `${this.bffUrl}/v1/consumer-profile/email-address`,
      body: {
        emailAddress,
      },
    })
  }
}
